var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCertificateLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 83.5,
    r: 83.5,
    fill: "#E7E7D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9823 28.2974L44.512 34.9005C42.2337 35.2816 40.5645 37.2533 40.5645 39.5633V95.7673C40.5645 119.48 59.7873 138.703 83.4999 138.703C107.212 138.703 126.435 119.48 126.435 95.7673V39.5483C126.435 37.245 124.775 35.2769 122.505 34.8884L83.9823 28.2974Z",
    fill: "#FF7E77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9178 36.041L50.9351 41.5236C48.2918 41.963 46.354 44.2495 46.354 46.9291V93.8045C46.354 114.32 62.985 130.951 83.5004 130.951C104.016 130.951 120.647 114.32 120.647 93.8045V46.9127C120.647 44.2402 118.719 41.9574 116.085 41.5095L83.9178 36.041Z",
    fill: "#E74F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.5814 34.6281L82.8865 28.4985C95.6445 78.2446 60.3965 99.3005 41.1778 103.61L40.601 39.3388C40.58 37.0002 42.2721 34.9976 44.5814 34.6281Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.963 62.9274L108.96 62.9302H58.6707L58.668 62.9274L65.3764 50.4644H102.243L102.248 50.4762L105.569 56.6319L106.18 57.7646L108.963 62.9274Z",
    fill: "#D5A67F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5555 87.4765L83.8138 91.255L79.1681 94.3109L58.6712 62.937L58.6675 62.9336L61.073 58.4746L61.4522 57.7698L62.0597 56.6383L62.4389 55.9333L65.3815 50.4839L73.5181 62.937L83.8138 78.6928L89.5555 87.4765Z",
    fill: "#EBBD97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.674 89.8602L82.5356 91.2772L61.0728 58.4686L61.452 57.7638L62.0594 56.6323L62.4387 55.9272L84.674 89.8602Z",
    fill: "#DEDEC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0757 87.4765L83.817 91.255L88.4627 94.3109L108.96 62.937L108.963 62.9336L106.558 58.4746L106.179 57.7698L105.571 56.6383L105.192 55.9333L102.249 50.4839L94.113 62.937L83.817 78.6928L78.0757 87.4765Z",
    fill: "#EBBD97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9551 89.8602L85.0937 91.2772L106.556 58.4686L106.177 57.7638L105.57 56.6323L105.19 55.9272L82.9551 89.8602Z",
    fill: "#DEDEC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8429 100.695C100.765 92.3662 95.5955 84.0506 87.2977 82.1218C78.9998 80.193 70.7153 85.3814 68.7938 93.7104C66.8722 102.039 72.0412 110.355 80.339 112.284C88.6369 114.213 96.9214 109.024 98.8429 100.695Z",
    fill: "#FCD36F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5563 100.168C98.2005 93.0416 93.7778 85.9267 86.6781 84.2764C79.5784 82.6261 72.4902 87.0654 70.8461 94.1918C69.202 101.318 73.6246 108.433 80.7243 110.083C87.824 111.734 94.9122 107.294 96.5563 100.168Z",
    fill: "#FAC032"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7168 93.1594C80.7298 92.6601 81.5297 92.3745 82.8269 90.8223H85.9906V100.92H87.6435V103.292H80.5344V100.92H82.3118V94.3011L80.5344 95.1395L79.7168 93.1594Z",
    fill: "#FFE9C1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCertificateLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/certificate-logo.5613d512.svg";
export { ForwardRef as ReactComponent };